var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InformeDetailView',{attrs:{"fetch-path":"informe-auditoria","toolbar-title":"Informes","type-label":"Tipo de Informe","descripion-label":"Observación"}})}
var staticRenderFns = []

export { render, staticRenderFns }